export default __webpack_public_path__ + "static/media/CSharp.4c163209.png";